import TagIcon from "@redotech/redo-icons/tag-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

export const ShopifyTagFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter<string> => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  data: {
    name: "shopifyOrderTags",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "tag",
  Icon: TagIcon,
  valueFetcher: fetcher,
  itemGenerator: (item: string) => ({
    id: item,
    value: item,
    type: "badge",
    badge: { text: item },
  }),
  displayName: "Marketplace order tag",
  dbSearch: true,
});
